import { render } from "./country.vue?vue&type=template&id=071788fb&ts=true"
import script from "./country.ts?vue&type=script&lang=ts&external"
export * from "./country.ts?vue&type=script&lang=ts&external"

import "./country.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__